import { getAccounts } from "../APIs";

export function promiseOf(func, ...args) {
    return new Promise(function(resolve, reject) {
        func(...args, (err, res) => {
            if (err) {
                reject(err);
            }
            resolve(res);
        })
    })
}

export function promiseTo(func, ...args) {
    const promise = new Promise(function(resolve, reject) {
        console.log(func);
        func(...args, {
            onSuccess: (res) => {
                console.log("onSuccess");
                resolve(res);
            },
            onFailure: (err) => { 
                console.log("onFailure");
                reject(err);
            }
        })
    })
    console.log(promise);
    return promise;
}
export function getUrlVars() {
    var vars = {};
    var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
        vars[key] = value;
    });
    return vars;
}

export function parseJwt(token) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
};

export function generateMap(list, id) {
    const map = {};
    for (let i = 0; i < list.length; i++) {
        const cur = list[i];
        map[cur[id]] = cur;
    }
    return map;
}

export function errorHandler(err, callback) {
    let handler = alert;
    if (callback) {
        handler = callback;
    }
    console.log(err);
    if (err == undefined || err == null) {
        handler("Sorry, we got an error.");
        return;
    }
    if (err.response && err.response.data && err.response.data.message && err.response.data.message.message) {
        handler(err.response.data.message.message);
        return;
    }
    if (err.response && err.response.data && err.response.data.message) {
        handler(err.response.data.message);
        return;
    }
    // if (err.response && err.response.data && err.response.data.Error) {
    //     handler(err.response.data.Error);
    //     return;
    // }
    if (err.response && err.response.data) {
        if (typeof err.response.data == 'object') {
            handler(JSON.stringify(err.response.data));
            return;
        } 
        if (typeof err.response.data == 'string') {
            handler(err.response.data);
            return;
        }
    }
    if (err.response) {
        handler(JSON.stringify(err.response));
        return;
    }
    if (err.message) {
        handler(err.message);
        return;
    }
    if (err) {
        handler(err);
        return;
    }
}

export function getParentResource(path) {
    const lastSlashIndex = path.lastIndexOf('/');
    const parentPath = path.slice(0, lastSlashIndex);
    const parentName = path.slice(lastSlashIndex + 1);
    return {
        path: parentPath,
        resourceName: parentName
    };
}
export function findPermissionsInMap(map, path) {
    let targetPath = path;
    const foundPermissions = map[targetPath] || [];
    while (targetPath != "/root") {
        targetPath = getParentResource(targetPath).path;
        if (map[targetPath + "/*"]) {
            foundPermissions.push(...map[targetPath + "/*"]);
        }
    }
    return foundPermissions;
}

export function merchantInfoDisplayer(merchant) {
    if (!merchant) return "";
    const {name, address1, city, state, zip_code, merchantId, last_login_timestamp} = merchant;
    const detail = `${address1 ? address1 + ", " : ""}${city ? city + ", ": ""}${state ? state + ", ": ""}${zip_code ? zip_code : ""}`;

    return `${merchantId ? merchantId : ""}/${last_login_timestamp ? last_login_timestamp.substring(0, 10) : ""}: ${name ? name: ""} ${detail.length > 0 ? "(" + detail + ")" : ""}` 
}

export function validateEmail(email) {
    return /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/g.test(email);
}

export function removeURLParameter(url, parameter) {
    //prefer to use l.search if you have a location/link object
    var urlparts = url.split('?');   
    if (urlparts.length >= 2) {

        var prefix = encodeURIComponent(parameter) + '=';
        var pars = urlparts[1].split(/[&;]/g);

        //reverse iteration as may be destructive
        for (var i = pars.length; i-- > 0;) {    
            //idiom for string.startsWith
            if (pars[i].lastIndexOf(prefix, 0) !== -1) {  
                pars.splice(i, 1);
            }
        }

        return urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : '');
    }
    return url;
}

export function getOAuth2SearchString() {
    let search = window.location.search;
    if (search.startsWith('?')) {
        search = search.slice(1)
    }
    const searchParams = new URLSearchParams(search);
    const oauth2_param_names = ["redirect_uri", "code_challenge", "code_challenge_method"]
    let oauth2_params = new URLSearchParams();
    for (let name of oauth2_param_names) {
        if (searchParams.get(name)) {
            oauth2_params.append(name, searchParams.get(name))
        }
    }
    return oauth2_params.toString()
}